"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["Failed"] = "FAILED";
    TransactionType["DebitPayment"] = "DEBIT_PAYMENT";
    TransactionType["CreditPayment"] = "CREDIT_PAYMENT";
    TransactionType["CreditDeposit"] = "CREDIT_DEPOSIT";
    TransactionType["DebitWithdrawal"] = "DEBIT_WITHDRAWAL";
    TransactionType["CancelWithdrawal"] = "CANCEL_WITHDRAWAL";
    TransactionType["DebitOutgoingPayment"] = "DEBIT_OUTGOING_PAYMENT";
    TransactionType["CreditIncomingPayment"] = "CREDIT_INCOMING_PAYMENT";
    TransactionType["ExchangeBuy"] = "EXCHANGE_BUY";
    TransactionType["ExchangeSell"] = "EXCHANGE_SELL";
    TransactionType["ExchangeFee"] = "EXCHANGE_FEE";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
//# sourceMappingURL=transaction-type.js.map